import Vue from 'vue'

const state = {
    parking: {},
    parking_transaction: {},
    transactions_user: {},
    users: {},
    booking: {},
    booking_request: {},
    authorization: {},
    feedback: {},
    coupon: {},
    coupon_type: {},
    owner: {},
    email_case: {}
}
const getters = {}
const actions = {}
const mutations = {
    set_filter (state, data) {
        for (let field of data.fields) {
            Vue.set(state[data.page], field.name, field.value)
        }
    },
    update_filter (state, data) {
        let filter = state[data.page][data.colName]
        if (data.fieldName == 'all') {
            for (let key in filter) {
                Vue.set(filter, key, data.value);
            }
        } else {
            Vue.set(filter, data.fieldName, data.value);
            let count = 0
            for (let key in filter) {
                if (filter[key]) count++
            }
            let max = Object.keys(filter).length
            if (count == max - 1) { // "выбрать все"
                Vue.set(filter, 'all', data.value);
            }
        }
    },
    update_all (state, data) {
        state[data.page] = data.filters
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}